import { getAuthRoleNames } from "../services/authService";

/**
 * Mirrors RoleSeeder clinical access for UI gating (export PDF).
 * Owner bypass matches backend User::hasPermission().
 */
const ROLES_WITH_CLINICAL_VIEW: ReadonlySet<string> = new Set([
  "owner",
  "manager",
  "receptionist",
  "professional",
]);

const ROLES_WITH_CLINICAL_MANAGE: ReadonlySet<string> = new Set([
  "owner",
  "manager",
  "receptionist",
]);

export function canViewClinicalRecords(): boolean {
  const roles = getAuthRoleNames();

  return roles.some((role) => ROLES_WITH_CLINICAL_VIEW.has(role));
}

export function canExportClinicalRecords(): boolean {
  return canViewClinicalRecords();
}

export function canManageClinicalRecords(): boolean {
  const roles = getAuthRoleNames();

  return roles.some((role) => ROLES_WITH_CLINICAL_MANAGE.has(role));
}
